import React from 'react';
import { clsx } from 'clsx';

export default function StyleCard({ title, subtitle, image, onClick, selected, error }) {
  return (
    <div>
      <div
        onClick={onClick}
        className={clsx(
          'relative rounded-lg overflow-hidden cursor-pointer group transition-all',
          'border-2',
          error ? 'border-red-500' : selected ? 'border-indigo-600' : 'border-gray-200 hover:border-indigo-400'
        )}
      >
      {image ? (
        <div className="aspect-[4/3] relative">
          <img
            src={image}
            alt={title}
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-black bg-opacity-40 flex items-center justify-center">
            <div className="text-center text-white p-4">
              <h3 className="font-semibold">{title}</h3>
              {subtitle && (
                <p className="text-sm text-gray-200">{subtitle}</p>
              )}
            </div>
          </div>
        </div>
      ) : (
        <div className="aspect-[4/3] bg-gray-100 flex items-center justify-center p-4">
          <div className="text-center">
            <h3 className="font-semibold text-gray-900">{title}</h3>
            {subtitle && (
              <p className="text-sm text-gray-500">{subtitle}</p>
            )}
          </div>
        </div>
      )}
      </div>
      {error && (
        <p className="text-red-600 text-sm mt-2">{error}</p>
      )}
    </div>
  );
}